/**
 *  @class
 *  @function BlogSearch
 */
if (!customElements.get('blog-search')) {
  class BlogSearch extends HTMLElement {
    constructor() {
      super();
      this.searchInput = this.querySelector('input[type="text"]');
      this.articles = document.querySelectorAll('.blog-post');
      this.noResults = this.querySelector('.no-results');
      this.searchResults = this.querySelector('.search-results');
      
      this.init();
    }

    init() {
      if (!this.searchInput) return;
      
      this.searchInput.addEventListener('input', this.debounce((event) => {
        this.filterArticles(event.target.value);
      }, 300));
    }

    filterArticles(searchTerm) {
      const term = searchTerm.toLowerCase().trim();
      let visibleCount = 0;

      this.articles.forEach(article => {
        const title = article.querySelector('h5 a')?.textContent.toLowerCase() || '';
        const excerpt = article.querySelector('.post-excerpt p')?.textContent.toLowerCase() || '';
        const tags = Array.from(article.querySelectorAll('.tag-link')).map(tag => tag.textContent.toLowerCase()).join(' ');
        
        const isMatch = title.includes(term) || excerpt.includes(term) || tags.includes(term);
        
        if (isMatch || term === '') {
          article.style.display = 'block';
          visibleCount++;
        } else {
          article.style.display = 'none';
        }
      });

      this.showNoResults(visibleCount === 0 && term !== '');
    }

    showNoResults(show) {
      if (!this.noResults) {
        this.createNoResultsElement();
      }
      
      if (show) {
        this.noResults.style.display = 'block';
      } else {
        this.noResults.style.display = 'none';
      }
    }

    createNoResultsElement() {
      this.noResults = document.createElement('div');
      this.noResults.className = 'no-results';
      this.noResults.innerHTML = `
        <div class="search-empty">
          <p>${window.theme.strings.blogSearchNoResults}</p>
          <button type="button" class="clear-search button secondary medium">${window.theme.strings.blogSearchClear}</button>
        </div>
      `;
      
      this.searchResults = this.articles[0]?.closest('.articles');
      if (this.searchResults) {
        this.searchResults.appendChild(this.noResults);
      }

      // Add clear search functionality
      this.noResults.querySelector('.clear-search').addEventListener('click', () => {
        this.searchInput.value = '';
        this.filterArticles('');
        this.searchInput.focus();
      });
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  }
  
  customElements.define('blog-search', BlogSearch);
}

/**
 *  @class
 *  @function BlogSidebarToggle
 */
class BlogSidebarToggle extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.drawer = document.getElementById('Blog-Sidebar-Drawer');
    
    // Add functionality to toggle button
    this.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.toggle('open-cc');
      this.drawer.classList.toggle('active');
    });
  }
}

customElements.define('blog-sidebar-toggle', BlogSidebarToggle);